import script from "./GlobalHeader.vue?vue&type=script&lang=ts&setup=true"
export * from "./GlobalHeader.vue?vue&type=script&lang=ts&setup=true"

import "./GlobalHeader.vue?vue&type=style&index=0&id=749acafe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-749acafe"]])

export default __exports__